/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import type { SerializedStyles } from '@emotion/react';

import * as React from 'react';

import type { Svg } from '@coursera/coursera-ui/svg';

import type { Props as ButtonProps } from 'bundles/authentication-common/components/Button';
import Button from 'bundles/authentication-common/components/Button';

type Props = Omit<ButtonProps, 'primary' | 'ghost' | 'secondary'> & {
  icon?: Svg;
  iconColor?: string;
  customStyles?: SerializedStyles;
};

const styles = {
  root: css`
    border: 1px solid var(--cds-color-neutral-primary);
    color: var(--cds-color-neutral-primary);
    width: 100%;
    position: relative;

    svg {
      left: 24px;
      position: absolute;
      top: 15px;
    }

    &:focus {
      background-color: var(--cds-color-blue-25);
      color: var(--cds-color-neutral-primary);
      text-decoration: none;
    }

    @media (hover: hover) {
      &:hover {
        background-color: var(--cds-color-blue-25);
      }
    }

    &[disabled] {
      background-color: var(--cds-color-grey-200);
      color: var(--cds-color-neutral-primary-invert);

      @media (hover: hover) {
        &:hover {
          background-color: var(--cds-color-grey-200);
        }
      }
    }
  `,
};

const SocialButton = React.forwardRef(
  ({ children, icon: Icon, iconColor, customStyles, ...props }: Props, ref: React.Ref<HTMLButtonElement>) => (
    <Button {...props} css={[styles.root, customStyles]} ghost ref={ref}>
      {Icon && <Icon aria-hidden="true" color={iconColor} size={18} />}
      {children}
    </Button>
  )
);
SocialButton.displayName = 'SocialButton';

export default SocialButton;
